import { render, staticRenderFns } from "./Decoration8.vue?vue&type=template&id=cdd4f492&scoped=true"
import script from "./Decoration8.vue?vue&type=script&lang=js"
export * from "./Decoration8.vue?vue&type=script&lang=js"
import style0 from "./Decoration8.vue?vue&type=style&index=0&id=cdd4f492&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd4f492",
  null
  
)

export default component.exports